<template>
    <div class="q_input" style="margin-top:8px;padding:30px 30px 40px">
        <div class="input_list" :style="{marginTop: 0,paddingTop:0,border:'none'}">
            <template v-for="(agreement, index) in agreements">
                <EnrolmentAgreementItemEditor :key="'p'+agreement.questionNo" ref="agreementEditor"
                                              :agreement-index="index"
                />
            </template>

            <button class="btn_class_add" type="button" @click="addAgreement">
                {{$t('EnrolmentAgreementEditor_addAgreement')}}
            </button>
        </div>
    </div>
</template>

<script>
import {mapFields} from 'vuex-map-fields';
import {mapActions} from 'vuex';
import {
    ADD_AGREEMENT, MAX_AGREEMENTS,
} from '@common/store/modules/enrolment/editor.js';
import {requestAlert} from '@iamteacherpc/utils/iframe.js';
import EnrolmentAgreementItemEditor from '@iamteacherpc/components/editor/EnrolmentAgreementItemEditor.vue';
import {LIST_CHANGE, STOP_LIST_CHANGE} from '@common/store/modules/common/editor/questionList';

export default {
    name: 'EnrolmentAgreementEditor',

    components: {
        EnrolmentAgreementItemEditor,
    },

    data() {
        return {
            select: {
                grade: {
                    options: this.$store.state.enrolment.options.filterOptions.filters,
                },
            },
        };
    },

    computed: {
        ...mapFields('enrolment', ['form.agreements']),
    },

    methods: {
        ...mapActions('enrolment', {
            storeAddAgreement: ADD_AGREEMENT,
            stopListChange: STOP_LIST_CHANGE,
            listChange: LIST_CHANGE,
        }),

        addAgreement() {
            if (this.agreements.length === MAX_AGREEMENTS) {
                this.stopListChange();

                requestAlert({
                    title: this.$t('EnrolmentAgreementItemEditor_availableMaxAgreement', {max: MAX_AGREEMENTS}),
                    okText: this.$t('common_confirm'),
                })
                    .then(() => this.listChange());

                return;
            }

            this.storeAddAgreement();

            this.$nextTick(function () {
                this.focusAgreement(this.agreements.length - 1);
            });
        },

        focusQuestion() {
            this.$refs.input.focus();
        },

        focusAgreement(index) {
            this.$refs.agreementEditor[index].focusAgreement();
        },
    },
};
</script>

<style scoped>

</style>
